export const BRANCH_CODES = ['ww', 'bp', 'twn', 'llk'] as const;
export type BranchCode = (typeof BRANCH_CODES)[number];

export const BRANCH_LABELS: Record<BranchCode, string> = {
  ww: 'วงเวียน',
  bp: 'บางพลี',
  twn: 'ติวานนท์',
  llk: 'ลำลูกกา',
};

export const HUB_BRANCH: BranchCode = 'bp';
